import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const slug = "api";
const ItemWiseServices = {
  // Define your API functions here
  getList: async (supplierId) => {
    const response = await apiService.get(
      `${slug}/stock-report/supplierpurchaseditems?supplierId=${supplierId}`
    );
    return response.data;
  },
};

export default ItemWiseServices;
